import React from 'react';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="page-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you</p>
      </div>
      
      <div className="container">
        <div className="contact-grid">
          <div className="contact-info">
            <h3>Get in Touch</h3>
            <p>For any queries regarding your order, styling advice, or general information, please feel free to contact us.</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <strong>Email</strong>
                <a href="mailto:stonariofficial@gmail.com">stonariofficial@gmail.com</a>
              </div>
              <div className="contact-item">
                <strong>Phone</strong>
                <a href="tel:+917828740737">+91 78287 40737</a>
              </div>
              <div className="contact-item">
                <strong>Business Hours</strong>
                <p>Monday - Saturday: 10:00 AM - 7:00 PM (IST)</p>
              </div>
            </div>
          </div>
          
          <div className="contact-form">
            <h3>Send a Message</h3>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group">
                <label className="form-label">Name</label>
                <input type="text" className="form-input" placeholder="Your Name" required />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input type="email" className="form-input" placeholder="Your Email" required />
              </div>
              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea className="form-input" rows="5" placeholder="How can we help you?" required></textarea>
              </div>
              <button type="submit" className="btn btn-primary btn-full">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
